import axios, { AxiosInstance, AxiosRequestConfig } from "axios";
import { AuthService } from "../services/authService";

let  API_BASE_URL = "http://localhost:8000/api/admin"

if(process.env.NODE_ENV === 'production'){
    API_BASE_URL = 'https://api.mart-24.com/api/admin';
}

const createAxiosInstance = (config: AxiosRequestConfig): AxiosInstance => {
    const instance = axios.create({
        baseURL: API_BASE_URL,
        ...config
    });

    instance.interceptors.request.use(
        async (config) => {
            const token = await AuthService.getIdToken();
            //console.log(token);
            if (token) {
                config.headers['Authorization'] = `Bearer ${token}`;
            }
            return config;
        },
        (error) => Promise.reject(error)
    );

    return instance;
};

export const axiosInstance = createAxiosInstance({
    headers: {
        'Content-Type': 'application/json',
    }
});

export const axiosMultipartInstance = createAxiosInstance({
    headers: {
        'Content-Type': 'multipart/form-data',
    }
});

export default axiosInstance;
